import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IRTMPlanRequest, IAddRTMPlanRes } from './index.type';

const useAddRTMPlan = ({ RTMPlanId }: { RTMPlanId?: string }) => {
  const url = RTMPlanId ? `/rtm/plan?planId=${RTMPlanId}` : `/rtm/plan`;
  const method = RTMPlanId ? 'PUT' : 'POST';
  const { loading: addRTMPlanLoading, makeApiCall } = useApi({ url, method });
  
  const addRTMPlan = async (formData: IRTMPlanRequest) => {
    const { response, error } = await makeApiCall<IRTMPlanRequest, IAddRTMPlanRes>(formData);
    
    if (response?.status === 'success') {
      toast.success(RTMPlanId ? 'RTM Plan updated successfully' : 'RTM Plan added successfully');
      return response;
    }
    
    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to save RTM plan. Please check plan details and try again.');
      return { status: 'fail' };
    }
  };
  
  return {
    addRTMPlanLoading,
    addRTMPlan,
  };
};

export default useAddRTMPlan;

